export const openURL = (url: string, target: string = '_self') => {
  const a = document.createElement('a');
  a.href = url;
  a.target = target;
  return {
    ref: a,
    click: () => a.click()
  };
};
